// @flow
export { default } from './BannerTags';



// WEBPACK FOOTER //
// ./src/components/banner/BannerTags/index.js